import React from "react";
import { useState, useEffect } from "react";
import { IUserProps } from "../entitiesAPI";
import useStore from "../../apiFunctions/store/store";
import usePersistentStore from "../../apiFunctions/store/persistentStore";
import { useNavigate } from "react-router-dom";
import { getEndpoints, setEndpoints, MainPageSignalRWrapper, ISignalRUpdate, SignalRUpdateType, ISlimCachedDirectory } from "documentdrafter-components";
import { Input, Label, Link, PresenceBadge, Spinner, Badge, Title2, Title3, useId, Toast, ToastTitle, Toaster, tokens, useToastController, webDarkTheme, webLightTheme, Toolbar, ToolbarButton, TableRowId, DataGrid, DataGridHeader, DataGridRow, DataGridCell, DataGridBody, DataGridHeaderCell, createTableColumn, TableCellLayout, TableColumnDefinition, DialogContent, Dialog, DialogSurface, DialogBody, DialogActions, Button, DialogTitle, DataGridProps, PopoverSurface, Popover, PopoverTrigger, Option, Table, TableHeader, TableCell, TableRow, TableHeaderCell, TableBody, Checkbox } from "@fluentui/react-components";
import { getAuthObject } from "../../apiFunctions/authenticateFunctions";
import { GetAIUsageData } from "../../apiFunctions/baseFunctions/baseFunctions";
import { GetColumnsForSharePointLists, SearchAllSharePointLists, getSharePointTenant, DownloadAIUsageData } from "../../apiFunctions/baseFunctions/baseFunctions";
import { AddRegular, ArrowDownloadRegular, DeleteRegular, DismissRegular, EditRegular, RenameRegular, SearchRegular } from "@fluentui/react-icons";
import { IDataSet, IDataSetColumn, SharePointListsResourceMap } from "../ddentities";
import { SearchBox } from "@fluentui/react-search-preview";
import { result, set } from "lodash";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { object } from "prop-types";
import { resolve } from "dns";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export const AISupport: React.FC = () => {
    const userObj: IUserProps = useStore().userObj;
    const isUserAuthenticated = useStore().isUserAuthenticated;
    //SignalR
    const [documentsSignalRUpdateQueue, setDocumentsSignalRUpdateQueue] = useState<ISignalRUpdate[]>([]);
    const screenSize = useStore().screenSize;
    const portalConfig = useStore().portalConfig;
    const endPoints = useStore().endpoints;
    const isDark = usePersistentStore().darkMode;
    const theme = isDark ? webDarkTheme : webLightTheme;
    const navigate = useNavigate();
    const toasterId = useId("toaster");
    const { dispatchToast } = useToastController(toasterId);
    const [data, setData] = useState<any>([]);
    const [modelUsed, setModelUsed] = useState<string>("");
    const [regionUsed, setRegionUsed] = useState<string>("");
    const [fromDate, setFromDate] = useState<Date | null>(() => {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        return d;
    });
    const [toDate, setToDate] = useState<Date | null>(new Date());


    React.useEffect(() => {




     

        var _fromDate = new Date();
        _fromDate.setDate(fromDate.getDate() - 30); // 30 days ago
        var _toDate = new Date(); // today

        var getData = async () => {

            var result = await GetAIUsageData(userObj, _fromDate, _toDate);

            if (result.status == "ok") {
                setModelUsed(result.model);
                setRegionUsed(result.region);
                if (result.usage && result.usage.length > 0) {
                    //result.usage.forEach((item: any) => {
                    //    data.push({
                    //        Created: item.Created,
                    //        InputTokens: item.InputTokens,
                    //        OutputTokens: item.OutputTokens
                    //    });
                    //});
                   
                    setData(result.usage);

                } else {
                    notify("No AI usage data found for the last 30 days.");
                }
            }
            
        };

        getData();
    
    }, [])

  

    const notify = (text: string) =>
        dispatchToast(
            <Toast>
                <ToastTitle>{text}</ToastTitle>
            </Toast>,
            { position: "top-end", intent: "success" }
        );


    return (<div>


        <div
            style={{
                marginTop: tokens.spacingVerticalNone,
                marginBottom: tokens.spacingVerticalXL,
                marginLeft: "20px",
                maxWidth: "100%"

            }}
        >
            <Title2>AI Support</Title2>
        </div>

     

        {<div> <div
            style={{
                overflowX: "hidden",

                backgroundColor: tokens.colorNeutralBackground1,
                color: tokens.colorNeutralForeground1,
                borderTopLeftRadius: tokens.borderRadiusXLarge,
                borderTopRightRadius: tokens.borderRadiusXLarge,
                marginLeft: tokens.spacingHorizontalM,
                marginRight: tokens.spacingHorizontalM,
                height: "70dvh",
                width: "80dvw"

            }}

        >
            <Toolbar aria-label="Vertical Button" >


              

                    <DatePicker
                        value={fromDate}
                        onSelectDate={setFromDate}
                        placeholder="From date"
                        maxDate={toDate ?? undefined}
                    style={{ minWidth: 140 }}

                    />
                    <DatePicker
                        value={toDate}
                        onSelectDate={setToDate}
                        placeholder="To date"
                        minDate={fromDate ?? undefined}
                        maxDate={new Date()}
                        style={{ minWidth: 140, marginLeft:10, marginRight:10 }}
                    />
            
                <ToolbarButton icon={<ArrowDownloadRegular></ArrowDownloadRegular>} onClick={async ()  => {
                    const auth = await getAuthObject();
                    const { blob, filename } = await DownloadAIUsageData(userObj, fromDate, toDate);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                }}>
                    Download usage data 
                </ToolbarButton>
                <div style={{ flex: 1 }} />
                <Badge
                    appearance="tint"
                    color="informative"
                    style={{ minWidth: 400 }}

                >
                    Currently running {modelUsed}, in {regionUsed}
                </Badge>


            </Toolbar>
            
            <div
                style={{
                    overflowX: "hidden",

                    backgroundColor: tokens.colorNeutralBackground1,
                    color: tokens.colorNeutralForeground1,

                    marginLeft: tokens.spacingHorizontalM,
                    marginRight: tokens.spacingHorizontalM,
                    marginTop: tokens.spacingVerticalL,
                    height: "60dvh",
                    width: "80dvw"


                }}>


                <Title3>Token usage last 30 days</Title3>



                {data.length > 0 &&

                    <ResponsiveContainer width="100%" height="90%">

                        <BarChart
                            width={500}
                            height={300}
                            data={data}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="created" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="inputTokens" name="Input tokens" stackId="a" fill="#8884d8" />
                            <Bar dataKey="outputTokens" stackId="a" name="Output tokens" fill="#82ca9d" />
                        </BarChart>
                    </ResponsiveContainer>
                }

              
                

                </div>


        </div>
            <div
                style={{
                    height: "33px",
                    width: "80dvw",
                    backgroundColor: tokens.colorNeutralBackground1,
                    borderBottomRightRadius: tokens.borderRadiusXLarge,
                    borderBottomLeftRadius: tokens.borderRadiusXLarge,
                    marginLeft: tokens.spacingHorizontalM,
                }}
            />
          

        </div>
        }

        <Toaster toasterId={toasterId} />

    </div>
    );
}